<template>
  <div class="queryCurrencies">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <div v-if="item.field === 'isEnabled'" class="statusSever">
              <span v-if="scope.row['isEnabled'] == '1'">{{
                $t('currenciesAndCalendar.queryCurrencies.openstatic')
              }}</span>
              <span v-if="scope.row['isEnabled'] == '0'">{{
                $t('currenciesAndCalendar.queryCurrencies.enable')
              }}</span>
            </div>
            <span v-else v-html="scope.row[item.field]"></span>
          </template>
        </vxe-table-column>
      </SiruiTable>
    </div>
  </div>
</template>
<script>
  import API from '@/api/financeCenter/generalAccounting';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    name: 'queryCurrencies',
    mixins: [tableMixins],
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'currencyCode',
            name: this.$t('currenciesAndCalendar.queryCurrencies.currencyCode'),
            type: 'input',
            placeholder: this.$t('currenciesAndCalendar.queryCurrencies.writeCurrencyCode'),
          },
          {
            prop: 'currencyName',
            name: this.$t('currenciesAndCalendar.queryCurrencies.currencyName'),
            type: 'input',
            placeholder: this.$t('currenciesAndCalendar.queryCurrencies.writeCurrencyName'),
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        menuButtonList: [], //按钮
        query: {
          currencyCode: null, //币种代码
          currencyName: null, //币种名称
          currencyDesc: null, //说明
          publicRegion: null, //发行地区
          currencySymbol: null, //符号
          isEnabled: null, //状态
        },
        dataStateList: [
          { value: '1', label: this.$t('currenciesAndCalendar.queryCurrencies.openstatic') },
          { value: '0', label: this.$t('currenciesAndCalendar.queryCurrencies.enable') },
        ],
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        columnList: [],
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'currencyCode',
            title: 'currenciesAndCalendar.queryCurrencies.currencyCode',
            visible: true,
          },
          {
            field: 'currencyName',
            title: 'currenciesAndCalendar.queryCurrencies.currencyName',
            visible: true,
          },
          {
            field: 'currencyDesc',
            title: 'currenciesAndCalendar.queryCurrencies.currencyDesc',
            visible: true,
          },
          {
            field: 'publicRegion',
            title: 'currenciesAndCalendar.queryCurrencies.publicRegion',
            visible: true,
          },
          {
            field: 'currencySymbol',
            title: 'currenciesAndCalendar.queryCurrencies.currencySymbol',
            visible: true,
          },
          {
            field: 'isEnabled',
            title: 'currenciesAndCalendar.queryCurrencies.isEnabled',
            visible: true,
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      getData() {
        const {
          currencyCode,
          currencyName,
          currencyDesc,
          publicRegion,
          currencySymbol,
          isEnabled,
        } = this.query;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = {
          currencyCode,
          currencyName,
          currencyDesc,
          publicRegion,
          currencySymbol,
          isEnabled,
          pageNum,
          pageSize,
        };
        this.load = true;
        this.$axios.get(API.SEARCH_CURRENCYS, params).then((res) => {
          this.load = false;
          if (res.data.code == 0) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
            //更改选中数据状态
            if (this.multipleSelection.length > 0) {
              this.tableData.forEach((item) => {
                this.multipleSelection.forEach((val, index) => {
                  if (val.id == item.id) {
                    this.multipleSelection[index] = item;
                  }
                });
              });
            }
          }
        });
      },
      //禁用,启用
      changeStatic(val, valList) {
        if (valList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('currenciesAndCalendar.queryCurrencies.changeEditDatas'),
            type: 'error',
          });
        } else {
          if (val == 1) {
            let flag = valList.some((item) => {
              return item.isEnabled == 1;
            });
            if (!flag) {
              this.doChangeStatic(val, valList);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('currenciesAndCalendar.queryCurrencies.wrongChangeDatas'),
                type: 'error',
              });
            }
          } else if (val == 0) {
            let flag = valList.some((item) => {
              return item.isEnabled == 0;
            });
            if (!flag) {
              this.doChangeStatic(val, valList);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('currenciesAndCalendar.queryCurrencies.wrongChangeDatas'),
                type: 'error',
              });
            }
          }
        }
      },
      doChangeStatic(val, valList) {
        let params = JSON.parse(JSON.stringify(valList));
        params.forEach((item) => {
          item.isEnabled = val;
        });
        this.$axios.post(API.ENABLE_CURRENCYS, params).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'add') {
          this.toRouter();
        } else if (type == 'forbid') {
          this.changeStatic('0', this.multipleSelection); //禁用
        } else if (type == 'enable') {
          this.changeStatic('1', this.multipleSelection); //启用
        }
      },
      //双击事件
      dblclickEvent(value) {
        console.log(value);
      },
      //路由跳转
      toRouter() {
        let path = {
          path: '/generalAccounting/addCurrencies',
          name: 'addCurrencies',
          meta: {
            keepAlive: true,
            title: this.$t('currenciesAndCalendar.queryCurrencies.addCurrencies'),
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
